import React from "react";
import Arrow from "../../assets/taiga-uikit/icons/arrow-right-1.svg?react";
import { _size, _style } from "../../core/core";
import { Link } from "../link/link";
import "./BreadCrumbs.css";

interface BreadCrumbLink {
  url: string;
  name: string;
}

interface BreadCrumbsProps {
  links?: BreadCrumbLink[];
  [key: string]: any;
}

export const BreadCrumbs: React.FC<BreadCrumbsProps> = ({
  links = [],
  ...props
}) => {
  const lastLink = links.pop();
  return (
    <nav aria-label="Breadcrumb" className="bread-crumbs" {...props}>
      <ol itemScope itemType="https://schema.org/BreadcrumbList">
        {links.map((link, index) => (
          <li
            key={index}
            className="breadcrumb-item"
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <Link
              link={link.url}
              size={_size.S}
              style={_style.link}
              icon_right={<Arrow />}
            >
              <span itemProp="name">{link.name}</span>
            </Link>
            <meta itemProp="position" content={(index + 1).toString()} />
          </li>
        ))}
        {lastLink && (
          <li
            className="breadcrumb-item"
            aria-current="page"
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <Link link={lastLink.url} size={_size.S} style={_style.link}>
              <span itemProp="name">{lastLink.name}</span>
            </Link>
            <meta itemProp="position" content={(links.length + 1).toString()} />
          </li>
        )}
      </ol>
    </nav>
  );
};
